import { Chart } from 'chart.js';
import { AuthProvider } from './../../providers/auth/auth';
import { FoserviceProvider } from './../../providers/foservice/foservice';
import { Component, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, Content } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';

@IonicPage()
@Component({
  selector: 'page-fo-statistic',
  templateUrl: 'fo-statistic.html',
})
export class FoStatisticPage {
  @ViewChild('todayPieChart') todayPieChart;
  @ViewChild('monthlyPieChart') monthlyPieChart;
  @ViewChild('sourcePieChart') sourcePieChart;
  @ViewChild(Content) content: Content;
  public todayPieChartEl: any;
  public monthlyPieChartEl: any;
  public sourcePieChartEl: any;

  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';

  activeTab: string = 'today';

  //Today Occupancy
  selectedDate: string = '';
  todayDate = '';
  todayRoomSold = 0;
  todayRoomSoldPct = 0;
  todayRoomAvailable = 0;
  todayRoomAvailablePct = 0;
  todayTotalRoom = 0;
  todayRoomPayable = 0;
  todayCompliment = 0;
  todayDayUse = 0;
  todayExpectedDeparture = 0;
  todayExpectedArrival = 0;

  //Revenue Today (Income Audit Today)
  todayRevenue: any[] = [];

  //Monthly Occupancy (Report Statistic MTD)
  selectedMonth: number;
  selectedYear: number;
  monthOptions: { value: number, label: string }[] = [];
  yearOptions: number[] = [];
  roomSold = 0;
  roomSoldPct = 0;
  roomAvailable = 0;
  roomAvailablePct = 0;
  totalRoom = 0;
  roomPayable = 0;
  compliment = 0;
  dayUse = 0;

  //Revenue (Income Audit MTD)
  revenue: any[] = [];

  //Loading flags
  todayLoaded: boolean = false;
  monthlyLoaded: boolean = false;

  //Average Daily Occupancy
  avgDailyOccupancy: any[] = [];

  //Source Of Booking
  sourceBooking: any[] = [];

  //Average Ratio
  avgARR = 0;
  avgRevPAR = 0;
  avgOccupancyRate = 0;
  private _destroyed = false;
  private _loaded = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private foservice: FoserviceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider,
    private cdr: ChangeDetectorRef) {

    let info = this.auth.getUserInfo();
    this.name = info.name;
    this.username = info.username;
    this.serverlocation = info.serverlocation;
    this.userid = info.userid;
    this.token = info.token;

    let now = new Date();
    this.selectedDate = now.toISOString();

    let months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    this.monthOptions = months.map((m, i) => ({ value: i + 1, label: m }));
    this.yearOptions = [];
    let cy = now.getFullYear();
    for (let y = cy; y >= cy - 2; y--) {
      this.yearOptions.push(y);
    }
    this.selectedMonth = now.getMonth() + 1;
    this.selectedYear = now.getFullYear();
  }

  onDateChange() {
    this.loadTodayOccupancy();
  }

  onPeriodChange() {
    if (this.activeTab === 'monthly') {
      this.loadMonthlyData(true);
    }
  }

  switchTab(tab: string) {
    this.activeTab = tab;
    this.safeDetectChanges();
    if (tab === 'today') {
      setTimeout(() => this.createTodayPieChart(), 100);
    } else {
      if (!this.monthlyLoaded) {
        this.loadMonthlyData(true);
      } else {
        setTimeout(() => {
          this.createMonthlyPieChart();
          if (this.sourceBooking.length > 0) {
            this.createSourcePieChart();
          }
        }, 100);
      }
    }
  }

  private safeDetectChanges() {
    if (this._destroyed) return;
    try { this.cdr.detectChanges(); } catch(e) {}
  }

  loadTodayOccupancy() {
    this.todayLoaded = false;

    let d = new Date(this.selectedDate);
    let dtToCheck = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);

    this.foservice.loadTodayOccupancy(this.userid, this.token, this.serverlocation, this.global.ICNO, dtToCheck)
      .then((data: any) => {
        if (data && data.status === 200 && data.data) {
          this.fillTodayOccupancy(data);
        } else {
          // this.fillTodayOccupancyDummy();
        }
      })
      .catch(() => {
        // this.fillTodayOccupancyDummy();
      })
      .then(() => {
        this.todayRoomSold = this.todayRoomPayable;
        this.todayRoomAvailable = this.todayTotalRoom - this.todayRoomSold;

        if (this.todayTotalRoom > 0) {
          this.todayRoomSoldPct = Math.round((this.todayRoomSold / this.todayTotalRoom) * 100);
          this.todayRoomAvailablePct = 100 - this.todayRoomSoldPct;
        } else {
          this.todayRoomSoldPct = 0;
          this.todayRoomAvailablePct = 0;
        }

        this.foservice.loadIncomeAuditToday(this.userid, this.token, this.serverlocation, this.global.ICNO, dtToCheck)
          .then((data: any) => {
            if (data && data.status === 200 && data.data) {
              this.fillTodayRevenue(data);
            } else {
              this.fillTodayRevenueDummy();
            }
          })
          .catch(() => {
            this.fillTodayRevenueDummy();
          })
          .then(() => {
            this.todayLoaded = true;
            this.safeDetectChanges();
            setTimeout(() => this.createTodayPieChart(), 300);
          });
      });
  }

  fillTodayOccupancy(data) {
    let rec = data.data;
    this.todayTotalRoom = rec.total_room || 0;
    this.todayRoomPayable = rec.room_payable || 0;
    this.todayCompliment = rec.compliment || 0;
    this.todayDayUse = rec.day_use || 0;
    this.todayExpectedDeparture = rec.expected_departure || 0;
    this.todayExpectedArrival = rec.expected_arrival || 0;
  }

  fillTodayOccupancyDummy() {
    this.todayTotalRoom = 68;
    this.todayRoomPayable = 37;
    this.todayCompliment = 0;
    this.todayDayUse = 0;
    this.todayExpectedDeparture = 2;
    this.todayExpectedArrival = 0;
  }

  fillTodayRevenue(data) {
    let rows = <any[]>data.data;
    let sums = {};
    let k: any;
    for (k in rows) {
      let rec = rows[k];
      if (rec.revClassName != 'Revenue') continue;
      if (sums[rec.MasterName] == null) sums[rec.MasterName] = 0;
      sums[rec.MasterName] += Number(rec.TTD || 0);
    }

    let mapping = {
      'ROOM': 'Room',
      'OUTLET REVENUE': 'Food & Beverage',
      'OTHER REVENUE': 'Other Income'
    };

    this.todayRevenue = [];
    let total = 0;
    for (k in mapping) {
      let val = sums[k] || 0;
      this.todayRevenue.push({ Description: mapping[k], Amount: val });
      total += val;
    }
    this.todayRevenue.push({ Description: 'Total', Amount: total });
  }

  fillTodayRevenueDummy() {
    this.todayRevenue = [
      { Description: 'Room', Amount: 0 },
      { Description: 'Food & Beverage', Amount: 0 },
      { Description: 'Other Income', Amount: 0 },
      { Description: 'Total', Amount: 0 }
    ];
  }

  public loadData() {
    if (this.activeTab === 'today') {
      this.loadTodayOccupancy();
    } else {
      this.loadMonthlyData(true);
    }
  }

  private loadMonthlyData(showLoader: boolean) {
    if (showLoader) this.showLoading();
    this.monthlyLoaded = false;

    let periodYear = this.selectedYear;
    let periodMonth = this.selectedMonth;
    let now = new Date();
    let currentYear = now.getFullYear();
    let currentMonth = now.getMonth() + 1;

    let dtToCheck: string = null;
    if (periodYear < currentYear || (periodYear === currentYear && periodMonth < currentMonth)) {
      let lastDay = new Date(periodYear, periodMonth, 0);
      dtToCheck = lastDay.getFullYear() + '-' + ('0' + (lastDay.getMonth() + 1)).slice(-2) + '-' + ('0' + lastDay.getDate()).slice(-2);
    }

    let dtIncomeAudit: string = null;
    if (periodYear < currentYear || (periodYear === currentYear && periodMonth < currentMonth)) {
      let lastDay = new Date(periodYear, periodMonth, 0);
      dtIncomeAudit = lastDay.getFullYear() + '-' + ('0' + (lastDay.getMonth() + 1)).slice(-2) + '-' + ('0' + lastDay.getDate()).slice(-2);
    }

    let periode = periodYear.toString() + ('0' + periodMonth).slice(-2);

    this.foservice.loadStatisticMTD(this.userid, this.token, this.serverlocation, this.global.ICNO, dtToCheck)
      .then((data: any) => {
        this.fillStatistic(data);
      })
      .catch(err => {
        console.log('statistic_mtd failed, using dummy data');
        console.log(err);
        this.fillStatisticDummy();
      })
      .then(() => {
        this.foservice.loadIncomeAuditMTD(this.userid, this.token, this.serverlocation, this.global.ICNO, dtIncomeAudit)
          .then((data: any) => {
            if (data && data.status === 200 && data.data) {
              this.fillRevenue(data);
            } else {
              this.fillRevenueDummy();
            }
          })
          .catch(err => {
            console.log('income_audit_mtd failed, using dummy data');
            console.log(err);
            this.fillRevenueDummy();
          })
          .then(() => {
            this.foservice.loadSourceOfBooking(this.userid, this.token, this.serverlocation, this.global.ICNO, periode)
              .then((data: any) => {
                if (data && data.status === 200 && data.data && data.data.length > 0) {
                  this.fillSourceBooking(data.data);
                } else {
                  this.fillSourceBookingDummy();
                }
              })
              .catch(() => {
                this.fillSourceBookingDummy();
              })
              .then(() => {
                this.foservice.loadAvgOccupancyRatio(this.userid, this.token, this.serverlocation, this.global.ICNO, dtToCheck)
                  .then((data: any) => {
                    if (data && data.status === 200 && data.data) {
                      this.fillAvgDailyOccupancy(data.data);
                      this.fillAvgRatio(data.data);
                    } else {
                      this.fillAvgDailyOccupancyDummy();
                      this.fillAvgRatioDummy();
                    }
                  })
                  .catch(() => {
                    this.fillAvgDailyOccupancyDummy();
                    this.fillAvgRatioDummy();
                  })
                  .then(() => {
                    this.monthlyLoaded = true;
                    if (this.loading) this.loading.dismiss();
                    this.safeDetectChanges();
                    setTimeout(() => {
                      this.createMonthlyPieChart();
                      if (this.sourceBooking.length > 0) {
                        this.createSourcePieChart();
                      }
                    }, 300);
                  });
              });
          });
      });
  }

  fillStatistic(data) {
    if (!data || data.status !== 200 || !data.data) {
      this.fillStatisticDummy();
      return;
    }

    let rec = data.data;
    this.totalRoom = (rec.total_room && rec.total_room.mtd) || 0;
    this.roomPayable = (rec.room_payable && rec.room_payable.mtd) || 0;
    this.compliment = (rec.compliment && rec.compliment.mtd) || 0;
    this.dayUse = (rec.day_use && rec.day_use.mtd) || 0;

    this.roomSold = this.roomPayable;
    this.roomAvailable = this.totalRoom - this.roomSold;

    if (this.totalRoom > 0) {
      this.roomSoldPct = Math.round((this.roomSold / this.totalRoom) * 100);
      this.roomAvailablePct = 100 - this.roomSoldPct;
    } else {
      this.roomSoldPct = 0;
      this.roomAvailablePct = 0;
    }
  }

  fillStatisticDummy() {
    this.totalRoom = 858;
    this.roomPayable = 648;
    this.compliment = 0;
    this.dayUse = 127;
    this.roomSold = this.roomPayable;
    this.roomAvailable = this.totalRoom - this.roomSold;
    this.roomSoldPct = Math.round((this.roomSold / this.totalRoom) * 100);
    this.roomAvailablePct = 100 - this.roomSoldPct;
  }

  fillRevenue(data) {
    let rows = <any[]>data.data;
    let sums = {};
    let k: any;
    for (k in rows) {
      let rec = rows[k];
      if (rec.revClassName != 'Revenue') continue;
      if (sums[rec.MasterName] == null) sums[rec.MasterName] = 0;
      sums[rec.MasterName] += Number(rec.MTD || 0);
    }

    let mapping = {
      'ROOM': 'Room',
      'OUTLET REVENUE': 'Food & Beverage',
      'OTHER REVENUE': 'Other Income'
    };

    this.revenue = [];
    let total = 0;
    for (k in mapping) {
      let val = sums[k] || 0;
      this.revenue.push({ Description: mapping[k], Amount: val });
      total += val;
    }
    this.revenue.push({ Description: 'Total', Amount: total });
  }

  fillRevenueDummy() {
    this.revenue = [
      { Description: 'Room', Amount: 228369091 },
      { Description: 'Food & Beverage', Amount: 0 },
      { Description: 'Other Income', Amount: 2000000 },
      { Description: 'Total', Amount: 230369091 }
    ];
  }

  fillAvgDailyOccupancyDummy() {
    this.avgDailyOccupancy = [
      { name: 'Sunday', value: 114 },
      { name: 'Monday', value: 100 },
      { name: 'Tuesday', value: 95 },
      { name: 'Wednesday', value: 103 },
      { name: 'Thursday', value: 101 },
      { name: 'Friday', value: 106 },
      { name: 'Saturday', value: 112 }
    ];
  }

  fillAvgDailyOccupancy(data: any) {
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let dayMap = {};
    for (let item of data.avg_daily_occupancy) {
      dayMap[item.day] = item.value;
    }
    this.avgDailyOccupancy = days.map(d => ({
      name: d,
      value: dayMap[d] || 0
    }));
  }

  fillSourceBookingDummy() {
    this.sourceBooking = [
      { name: 'AGODA APK', value: 10, color: '#e74c3c' },
      { name: 'AGODA DIR', value: 49, color: '#c0392b' },
      { name: 'BOOKING COM', value: 0, color: '#f39c12' },
      { name: 'IN PERSON', value: 23, color: '#27ae60' },
      { name: 'OTHER', value: 0, color: '#3498db' },
      { name: 'RED PARTNER', value: 11, color: '#2980b9' },
      { name: 'TIKET COM', value: 2, color: '#8e44ad' },
      { name: 'TRAVELOKA', value: 6, color: '#95a5a6' },
      { name: 'RP DIRECT', value: 0, color: '#bdc3c7' }
    ];
  }

  fillSourceBooking(rows: any[]) {
    let segmentMap = {};
    let totalNights = 0;

    for (let row of rows) {
      let seg = row.segmentName || 'OTHER';
      let nights = Number(row.Nights) || 0;
      if (!segmentMap[seg]) segmentMap[seg] = 0;
      segmentMap[seg] += nights;
      totalNights += nights;
    }

    let colors = ['#e74c3c', '#c0392b', '#f39c12', '#27ae60', '#3498db', '#2980b9', '#8e44ad', '#95a5a6', '#bdc3c7', '#1abc9c', '#d35400', '#7f8c8d'];
    let result = [];
    let i = 0;
    for (let seg in segmentMap) {
      let pct = totalNights > 0 ? Math.round((segmentMap[seg] / totalNights) * 100) : 0;
      result.push({ name: seg, value: pct, color: colors[i % colors.length] });
      i++;
    }

    result.sort((a, b) => b.value - a.value);
    this.sourceBooking = result;
  }

  fillAvgRatioDummy() {
    this.avgARR = 328746;
    this.avgRevPAR = 345786;
    this.avgOccupancyRate = 105;
  }

  fillAvgRatio(data: any) {
    this.avgARR = data.avg_arr || 0;
    this.avgRevPAR = data.avg_revpar || 0;
    this.avgOccupancyRate = data.avg_occ_rate || 0;
  }

  createSourcePieChart() {
    if (!this.sourcePieChart) return;
    if (this.sourcePieChartEl) {
      this.sourcePieChartEl.destroy();
    }
    let filtered = this.sourceBooking.filter(s => s.value > 0);
    this.sourcePieChartEl = new Chart(this.sourcePieChart.nativeElement,
      {
        type: 'pie',
        data: {
          labels: filtered.map(s => s.name + '= ' + s.value + ' %'),
          datasets: [{
            data: filtered.map(s => s.value),
            backgroundColor: filtered.map(s => s.color),
          }]
        },
        options: {
          maintainAspectRatio: true,
          legend: { display: false },
          title: { display: false }
        }
      });
  }

  createTodayPieChart() {
    if (!this.todayPieChart) return;
    if (this.todayPieChartEl) {
      this.todayPieChartEl.destroy();
    }
    let sold = this.todayRoomSold;
    let avail = this.todayRoomAvailable;
    let hasData = (sold + avail) > 0;
    let colors = hasData ? ['#26a65b', '#d1d5db'] : ['#d1d5db', '#e5e7eb'];
    this.todayPieChartEl = new Chart(this.todayPieChart.nativeElement,
      {
        type: 'doughnut',
        data: {
          labels: hasData ? ['Room Sold', 'Available'] : ['No Data'],
          datasets: [{
            data: hasData ? [sold, avail] : [1],
            backgroundColor: hasData ? colors : ['#d1d5db'],
          }]
        },
        options: {
          maintainAspectRatio: false,
          legend: { display: false },
          title: { display: false }
        }
      });
  }

  createMonthlyPieChart() {
    if (!this.monthlyPieChart) return;
    if (this.monthlyPieChartEl) {
      this.monthlyPieChartEl.destroy();
    }
    let sold = this.roomSold;
    let avail = this.roomAvailable;
    let hasData = (sold + avail) > 0;
    let colors = hasData ? ['#26a65b', '#d1d5db'] : ['#d1d5db', '#e5e7eb'];
    this.monthlyPieChartEl = new Chart(this.monthlyPieChart.nativeElement,
      {
        type: 'doughnut',
        data: {
          labels: hasData ? ['Room Sold', 'Available'] : ['No Data'],
          datasets: [{
            data: hasData ? [sold, avail] : [1],
            backgroundColor: hasData ? colors : ['#d1d5db'],
          }]
        },
        options: {
          maintainAspectRatio: false,
          legend: { display: false },
          title: { display: false }
        }
      });
  }

  formatNumber(value) {
    if (value == null) return '0';
    let num = Number(value);
    if (isNaN(num)) return '0';
    let parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  doRefresh(refresher) {
    this.loadData();
    setTimeout(() => {
      refresher.complete();
    }, 2000);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FoStatisticPage');
  }

  ionViewDidEnter() {
    this._destroyed = false;
    if (!this._loaded) {
      this._loaded = true;
      this.loadData();
    } else {
      setTimeout(() => {
        if (this.activeTab === 'today' && this.todayLoaded) {
          this.createTodayPieChart();
        } else if (this.activeTab === 'monthly' && this.monthlyLoaded) {
          this.createMonthlyPieChart();
          if (this.sourceBooking.length > 0) {
            this.createSourcePieChart();
          }
        }
      }, 300);
    }
    setTimeout(() => {
      this.adjustScrollPadding();
      this.safeDetectChanges();
      try { this.content.resize(); } catch(e) {}
    }, 100);
  }

  // Ionic 3: navbar is rendered by the parent (tabs/nav) wrapper, not inside
  // this page's own template, so we can't scope the query to page-fo-statistic.
  // We look at every ion-navbar in the DOM (the nav stack can keep old ones
  // around) and use the first one that's actually visible on screen.
  private getVisibleNavbarHeight(): number {
    const navbars = Array.from(document.querySelectorAll('ion-navbar')) as HTMLElement[];
    for (const nb of navbars) {
      if (nb.offsetParent !== null && nb.offsetHeight > 0) {
        return nb.offsetHeight;
      }
    }
    return 56; // fallback: standard Ionic 3 toolbar height
  }

  private adjustScrollPadding() {
    const height = this.getVisibleNavbarHeight();

    const scrollContent = document.querySelector('page-fo-statistic .scroll-content') as HTMLElement;
    if (scrollContent) scrollContent.style.paddingTop = height + 'px';

    const refresher = document.querySelector('page-fo-statistic ion-refresher') as HTMLElement;
    if (refresher) refresher.style.top = height + 'px';
  }

  ionViewWillLeave() {
    this._destroyed = true;
  }

}


// WEBPACK FOOTER //
// ./src/pages/fo-statistic/fo-statistic.ts